import { SearchLineWithLanguage } from "@/graphql/queries/SearchLineWithLanguage";

import {
  SearchLineWithLanguageQuery,
  SearchLineWithLanguageQueryVariables,
} from "@/graphql/generated/graphql";
import { useQueryWrapper } from "@/hooks/useQueryWrapper/useQueryWrapper";
import {
  UseHasLineWithLanguageArgs,
  UseHasLineWithLanguageReturn,
} from "./useHasLineWithLanguages.decl";

export function useHasLineWithLanguages<LanguageValue extends string>({
  languages,
}: UseHasLineWithLanguageArgs<LanguageValue>): UseHasLineWithLanguageReturn {
  const { data, loading } = useQueryWrapper<
    SearchLineWithLanguageQuery,
    SearchLineWithLanguageQueryVariables
  >(SearchLineWithLanguage, {
    variables: {
      filter: {
        or: languages.map((language) => ({
          language: {
            match: language,
          },
        })),
      },
      limit: 1,
    },
  });

  return {
    data,
    loading,
    hasLine: Boolean(data?.searchAuthorizedLines?.items?.[0]),
  };
}
